import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AppConstants } from '../constant'

@Injectable({
  providedIn: 'root'
})
export class OtpverifyserviceService {

  constructor(private http: Http) { }

  check(email, otp) {
    return new Promise((resolve, reject) => {
      const url = 'http://valobit.io/valobit/junkbox.php';

      const body = { 
          'url': 'http://valobit.io/valobit/user/verify_mail_otp',
          'data':
          {
            'email': email,
            'otp': otp
          }
        };
      let headers = new Headers();
      headers.append("Authorization", "Basic " + btoa("admin_pkyradaon2:dn8tL1@2"));
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      let options = new RequestOptions({ headers: headers });
      this.http.post(url, body, options ).subscribe((res: any) => {
      const response = JSON.parse(res._body);
      if (response.status) {
          resolve(response);
        } else { reject(response); }
      });
    });
}

resend(email) {
  return new Promise((resolve, reject) => {
    const url = 'http://valobit.io/valobit/junkbox.php';

    const body = { 
        'url': 'http://valobit.io/valobit/user/send_mail_otp',
        'data':
        {
          'email': email
        }
      };

    this.http.post(url, body).subscribe((res: any) => {
        const response = JSON.parse(res._body);
    if (response.status) {
        resolve(response);
      } else { reject(response); }
    });
  });
}

}
